export const endPoints = {
  BOOKING_FILTER: '/v1/booking/filter',
  BOOKING_FILTER_EXCEL: '/v1/booking/filter/excel',
  BOOKING_CANCEL_REASON: '/v1/booking/cancel/reason'
};
